// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1gbFw","list":"PatternAutocomplete_list__6fRtB"};